import { render } from "./VideoCarousel.vue?vue&type=template&id=a94dedbe&ts=true"
import script from "./VideoCarousel.vue?vue&type=script&lang=ts"
export * from "./VideoCarousel.vue?vue&type=script&lang=ts"

import "./VideoCarousel.vue?vue&type=style&index=0&id=a94dedbe&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__